// FILE: main.js

import { createApp } from 'vue'
import { Quasar, Dialog, Loading, Notify } from 'quasar'

// Import icon libraries
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'

// Import Quasar css
import 'quasar/src/css/index.sass'

// Assumes your root component is App.vue
// and placed in same folder as main.js
import App from './App.vue'

import { createRouter, createWebHashHistory } from 'vue-router'
import routes from '~pages'

import 'uno.css';

import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

const app = createApp(App)

//Directives
import { InRole } from '/src/common/auth/inroleDirective';
app.directive('inrole', InRole);

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

import JsonViewer from 'vue-json-viewer'
app.use(JsonViewer);


app.use(pinia)
app.use(Quasar, {
    plugins: [
        Dialog,
        Loading,
        Notify
    ],
})

app.use(router);

//Custom Plugins
//import dialogs from '@/common/plugin/dialogs';
//app.use(dialogs);

// Assumes you have a <div id="app"></div> in your index.html
app.mount('#app')
